<app-progress-bar></app-progress-bar>
<!-- uncomment for guidelines component to show. -->
<!-- <competers-material-guidelines></competers-material-guidelines> -->
<div class="app-container">
  <router-outlet></router-outlet>
</div>
